const getPrefix = (amount, forcePrefix) =>
  amount > 1 || forcePrefix ? `${amount}x ` : "";

const getCleanName = (name) =>
  name
    .toString()
    .replaceAll(/,[A-Za-z0-9]+/gi, (roomData) => `, ${roomData.substring(1)}`);

export const getRoomsLabels = (offerRoomDetails) => {
  if (!offerRoomDetails) {
    return [];
  }
  const roomsNames = offerRoomDetails.map((room) => room.nameOffer ?? room.name);
  const uniqueRoomNames = Array.from(new Set(roomsNames));
  const forcePrefix = uniqueRoomNames.length > 1;

  return uniqueRoomNames.map((roomName) => {
    const amount = roomsNames.filter((name) => name === roomName).length;
    const abbr = offerRoomDetails.find(
      (room) => (room.nameOffer ?? room.name) === roomName,
    )?.abbr ?? '';
    return {
      abbr,
      text: `${getPrefix(amount, forcePrefix)} ${getCleanName(roomName)}`,
    };
  });
};
